module.exports = __webpack_public_path__ + "img/frame (196).bbac032f.jpg";